const XPositionToNegativeOffset = {
  814: -3600,
  792: -7200,
  770: -10800,
  748: -14400,
  726: -18000,
  704: -21600,
  682: -25200,
  660: 0,
  638: -86400,
  616: -172800,
  594: -259200,
  572: -345600,
  550: -432000,
  528: -518400,
  506: -604800,
  484: -691200,
  462: -777600,
  440: -864000,
  418: -950400,
  396: -1036800,
  374: -1123200,
  352: -1209600,
  330: -1296000,
  308: -1382400,
  286: -1468800,
  264: -1555200,
  242: -1641600,
  220: -1728000,
  198: -1814400,
  176: -1900800,
  154: -1987200,
  132: -2073600,
  110: -2160000,
  88: -2246400,
  66: -2332800,
  44: -2419200,
  22: -2505600,
  0: -2592000,
}

export default XPositionToNegativeOffset



// WEBPACK FOOTER //
// ./src/components/sitewide/XPositionToNegativeOffset.js